import { Drawer } from "antd";
import { useEffect } from "react";
import { ThreadDetail } from "./ThreadDetail";
import { useIsMobile } from "../hooks/useBreakpoint";
import { markThreadRead } from "../api/threads";

type Props = {
  threadId: string | null;
  open: boolean;
  onClose: () => void;
  onAfterSend?: () => void;
  onAfterAction?: () => void;
};

export function ThreadDrawer({ threadId, open, onClose, onAfterSend, onAfterAction }: Props) {
  const isMobile = useIsMobile();

  // 打开抽屉视为"读取了这条线索",自动标记 inbound 为已读
  // 这样群组活动面板的"新回复" tag 在 onAfterAction 刷新后就会消失。
  useEffect(() => {
    if (!open || !threadId) return;
    markThreadRead(threadId)
      .then(() => onAfterAction?.())
      .catch(() => {
        // 静默 — 显式的标记已读 / 未读按钮还在,失败不影响主流程
      });
    // 只在抽屉首次为这个 threadId 打开时跑一次
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, threadId]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="right"
      width={isMobile ? "100%" : Math.min(880, typeof window !== "undefined" ? window.innerWidth - 200 : 880)}
      destroyOnClose
      maskClosable
      keyboard={false}
      closable={false}
      styles={{ body: { padding: 0, display: "flex", flexDirection: "column", height: "100%" } }}
    >
      <ThreadDetail
        threadId={threadId}
        showBack
        onClose={onClose}
        onAfterSend={onAfterSend}
        onAfterAction={async () => {
          onAfterAction?.();
          onClose();
        }}
      />
    </Drawer>
  );
}
